import React, { useContext, useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import styled from "@emotion/styled";
import { AuthContext } from "../shared/";
import Sidebar from "./Sidebar/Sidebar";
import HeaderController from "./Header/Header";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

import "./SidebarStyle.css?v=0.0.4";

const ContenedorForm = styled.div`
  @media (min-width: 800px) {
    width: 100%;
    margin: 0;
    min-height: 600px;
  }
`;

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const authContext = useContext(AuthContext);
  const { usuario, cerrarSesion } = authContext;
  const [sidebar, setSidebar] = useState({
    header: {
      marginLeft: "80px",
    },
    toolbar: {
      left: "80px",
    },
    dashboard: {
      display: "block",
      width: "80px",
    },
    state: true,
    automatic: true,
  });

  // Sincronizar sidebar al cambiar de página
  useEffect(() => {
    // Resetear al estado colapsado con hover automático al cambiar de ruta
    if (sidebar.automatic === false) {
      // Si estaba fijado manualmente, mantener el estado
      return;
    }

    // Si está en modo automático, asegurar que esté colapsado
    setSidebar({
      header: {
        marginLeft: "80px",
      },
      toolbar: {
        left: "80px",
      },
      dashboard: {
        display: "block",
        width: "80px",
      },
      state: true,
      automatic: true,
    });
  }, [pathname]);

  if (window.location.pathname.startsWith("/creditos/pagare/")) {
    return <>{children}</>;
  }

  const toggle = (e) => {
    let state = sidebar.state;
    let automatic = sidebar.automatic;

    // Si está colapsado (state = true), lo abrimos y desactivamos automático
    if (state) {
      setSidebar({
        ...sidebar,
        dashboard: {
          display: "block",
          width: "238px",
        },
        header: {
          marginLeft: "238px",
        },
        toolbar: {
          left: "238px",
        },
        state: false,
        automatic: false, // Desactivar hover cuando se abre manualmente
      });
    } else {
      // Si está abierto, lo cerramos y activamos automático
      setSidebar({
        ...sidebar,
        dashboard: {
          display: "block",
          width: "80px",
        },
        header: {
          marginLeft: "80px",
        },
        toolbar: {
          left: "80px",
        },
        state: true,
        automatic: true, // Activar hover cuando se cierra manualmente
      });
    }
  };

  const onMouseOver = (e, value) => {
    // Solo funciona si automatic está activado
    if (sidebar.automatic) {
      if (value) {
        // Expandir al hacer hover
        setSidebar({
          ...sidebar,
          dashboard: {
            display: "block",
            width: "238px",
          },
          header: {
            marginLeft: "238px",
          },
          toolbar: {
            left: "238px",
          },
          state: false,
          automatic: true, // Mantener automático en true
        });
      } else {
        // Colapsar al salir del hover
        setSidebar({
          ...sidebar,
          dashboard: {
            display: "block",
            width: "80px",
          },
          header: {
            marginLeft: "80px",
          },
          toolbar: {
            left: "80px",
          },
          state: true,
          automatic: true, // Mantener automático en true
        });
      }
    }
  };
  
  if(pathname.split('/')[2] == "ver"){
      return <ContenedorForm>{children}</ContenedorForm>
  }

  if (!usuario) {
    return (
      <div
        className="container-fluid"
        style={{
          backgroundColor:
            window.location.pathname === "/" ? "white" : "#ecf0f5",
          paddingBottom: "10px",
        }}
      >
        <ContenedorForm>{children}</ContenedorForm>
      </div>
    );
  }

  const colorRol = () => {
    let color;

    switch (usuario.rol) {
      case "Vendedor":
        color = "f68e1e";
        break;
      case "Admin":
        color = "414141";
        break;
      case "Cajero":
        color = "ac49b5";
        break;
      case "Analista":
        color = "6361bc";
        break;
      case "Precalificador":
        color = "6361bc";
        break;
      default:
        break;
    }

    return "#" + color;
  };

  return (
    <div class="dashboard">
      <div
        className={`modern-sidebar ${sidebar.state ? 'collapsed' : 'expanded'}`}
        onMouseOver={(event) => onMouseOver(event, true)}
        onMouseOut={(event) => onMouseOver(event, false)}
      >
        {usuario ? (
          <Sidebar
            usuario={usuario}
            pathname={pathname}
            hidden={sidebar.header.marginLeft == "80px" ? true : false}
          />
        ) : (
          ""
        )}
      </div>

      <div class="dashboard-app w-100" style={sidebar.header}>
        <header className={`modern-header ${sidebar.state ? 'sidebar-collapsed' : ''}`}>
          <a
            href="#!"
            class="menu-toggle me-5 d-md-none"
            onClick={(event) => toggle(event)}
            style={{
              position: 'fixed',
              left: '16px',
              top: '20px',
              zIndex: 1001,
              color: '#4b5563',
              fontSize: '28px'
            }}
          >
            <i class="bi bi-list"></i>
          </a>

          {usuario ? (
            <HeaderController
              usuario={usuario}
              pathname={pathname}
              cerrarSesion={cerrarSesion}
              onToggleSidebar={toggle}
            />
          ) : null}
        </header>

        <div class="dashboard-content" style={{width: "100%" ,marginTop: "80px" }}>
          <div class="container-fluid">
            <ContenedorForm>{children}</ContenedorForm>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {usuario ? (
        <>
          <Header usuario={usuario} cerrarSesion={cerrarSesion} />
          <Sidebar />
        </>
      ) : null}

      <div
        className="container-fluid"
        style={{
          backgroundColor:
            window.location.pathname === "/" ? "white" : "#ecf0f5",
          paddingBottom: "10px",
        }}
      >
        <ContenedorForm>{children}</ContenedorForm>
      </div>
      <Footer />
    </>
  );
};

export default Layout;
